import React from 'react'
import { QuizQuestionWrapper } from '../../QuizQuestionWrapper'
import { useContactInfo } from './ContactInfo.hook'
import './ContactInfo.scss'
import { OutlinedTextField, PhoneNumber } from 'src/common/components'
import { Dropdown } from 'src/common/components/select/Dropdown'
import { QuizType, REFERRAL_SOURCES } from 'src/pages/shared'
import { REDIRECT_PATH } from 'src/helpers'
import MetBeforeModal from 'src/pages/quiz/components/NewFlow/ContactInfo/components/MetBeforeModal'
import { useLocation } from 'react-router-dom'

export const ContactInfo = () => {
  const query = new URLSearchParams(useLocation().search)
  const isPinterestFlow = query.get('quizType') === QuizType.PINTEREST
  const {
    handleNext,
    handleBack,
    weddingDateData,
    formError,
    handleChangeInput,
    referralSource,
    handleChangeReferralSource,
    handleChangePhoneNumber,
    nextDisabled,
    loading,
    showMetBeforePopup,
    handleCloseMetBeforePopup,
    isPhoneOptional,
    isPhoneAndAttrOmitted,
  } = useContactInfo(query.get('quizType') as QuizType)

  return (
    <>
      <QuizQuestionWrapper
        titleStep="CONTACT INFO"
        title="Ready to see your proposal?"
        subtitle={isPinterestFlow ? '' : `(You’ll use this email to login later)`}
        nextAction={{
          disabled: true,
        }}
        backAction={{
          onAction: handleBack,
        }}
        customCss={{
          title: 'title-bold',
          content: 'contact-info-wrapper',
        }}
        step={7}
        total={7}
        className={isPinterestFlow ? 'pinterest-flow contact-info' : ''}
      >
        <div className="contact-info-section">
          <OutlinedTextField
            wrapperClass="mb-10px"
            inputClass="email"
            id="emailAddressId"
            value={weddingDateData.emailAddress ?? ''}
            type="text"
            name="emailAddress"
            onChange={handleChangeInput}
            label="Email address"
            isError={formError.emailAddress}
            errorMsg="Invalid email!"
          />
          {isPinterestFlow && <span className="form-sub-text">You’ll use your email to login to your proposal.</span>}
          {/* Phone and attribution fields are permanently removed */}
          <div className="action-box-wrapper mt-34px mb-30px">
            <button
              disabled={nextDisabled || loading}
              className={`button white-space-wrap see-your-proposal-btn ${loading ? 'loading' : ''}`}
              onClick={handleNext}
            >
              {isPinterestFlow ? 'GET MY PROPOSAL' : 'SEE YOUR PROPOSAL'}
            </button>
          </div>
          {/* Text message compliance text removed */}
        </div>
        <MetBeforeModal classes="contact-info-page" isOpen={showMetBeforePopup} onClose={handleCloseMetBeforePopup} />
      </QuizQuestionWrapper>
    </>
  )
}
